export default "__VITE_ASSET__TnNI1rCM__"